import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../routing/LangRouter";

//import utils
import { navigateToLoginPage } from "../../../utils/utility";

//import constants
import BASE_URL from "../../../constants/baseUrls";
import { IS_MOBILE } from "../../../constants/breakpoints";

//import general components
import { BaseButton } from "../../../components/common/base-button/base-button";
import BaseTitle from "../../../components/common/base-title/base-title";

//import view components
import Questions from "../../../components/view/favorites/questions/questions";

function UserFavorites() {
    //general variables
    const navigate = useNavigate();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const [loading, setLoading] = useState(false);
    const accessToken = localStorage.getItem("accessToken");
    const { t } = useTranslation();

    //state for storing user's favorite answers
    const [answers, setAnswers] = useState({});

    //handler for updating answers state
    const createAnswerObject = newAnswers => {
        setAnswers(newAnswers);
    };

    //form submit handler
    const submitAnswers = e => {
        e.preventDefault();
        editFavorites();
    };

    //submit favorites to user profile
    const editFavorites = async () => {
        const hasMinimumAnswers = countValidAnswers() > 7;

        if (!hasMinimumAnswers) {
            toast.error(t("favoritesMessage"), { toastId: "custom-id-yes" });
            return;
        }

        try {
            setLoading(true);
            await updateUserFavorites();
            showSuccessMessage();
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    //count valid answers
    const countValidAnswers = () => {
        return Object.values(answers).reduce((count, value) => (value > 0 ? count + 1 : count), 0);
    };

    //update user favorites
    const updateUserFavorites = async () => {
        await axios.patch(`${BASE_URL}/account/user/favorites/`, answers, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        });
    };

    //show success message
    const showSuccessMessage = () => {
        toast.success(t("requestSubmittedSuccessfully"), {
            toastId: "custom-id-yes",
        });
    };

    //handle error
    const handleError = error => {
        if (error.response?.status === 401) {
            localStorage.clear();
            navigateToLoginPage(navigate, locale, location);
        } else {
            toast.error(t("Toast Messages.Error Occurred"), {
                toastId: "custom-id-yes",
            });
        }
    };

    return (
        <Grid container item xs={12} rowGap={2} mt={{ xs: 2, md: 0 }} mb={5}>
            {!IS_MOBILE && <BaseTitle title={`${t("favorites")}`} dividerColor="1px solid var(--medium-gray-color)" />}
            <Grid container justifyContent="center" rowGap={5}>
                <Questions totalAnswers={createAnswerObject} />
                <Grid container item xs={10} sm={8} md={6} lg={4} justifyContent="center">
                    <BaseButton
                        text={t("submitFavorites")}
                        color="primary"
                        size="large"
                        radius="radius-10"
                        handleClick={submitAnswers}
                        loading={loading}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default UserFavorites;
